// ** Axios
import axios from 'axios'

import { createSlice, PayloadAction } from '@reduxjs/toolkit'

// ** API Imports
import { createMetadata, editMetadata, getMetaDataData } from 'configs/axios/api_helper'

export const initialState = {
  loading: null,
  commitmentDurations: [],
  success: '',
  error: '',
  pagination: {
    nextPage: null,
    previousPage: null,
    limit: 0,
    total: 0,
    currentPage: 1
  }
}
// A slice
const commitmentDurationSlice = createSlice({
  name: 'commitmentDurationData',
  initialState,
  reducers: {
    addCommitmentDuration: (state, action) => {
      state.commitmentDurations.push(action.payload)
      ;(state.success = 'CREATE'), (state.loading = null)
    },
    updateCommitmentDuration: (state, action) => {
      state.commitmentDurations = state.commitmentDurations.map(tax =>
        tax.id.toString() === action.payload.id.toString() ? { tax, ...action.payload } : tax
      )
      state.success = 'UPDATE'
      state.loading = null
    },
    removeCommitmentDuration: (state, action) => {
      state.commitmentDurations = state.commitmentDurations.filter(tax => tax.id !== action.payload)
      state.success = 'DELETE'
      state.loading = null
    },
    startLoading: (state, action) => {
      state.loading = action.payload
      state.error = ''
      state.success = ''
    },
    getCommitmentDurationDataSuccess: (state, action) => {
      const { data, ...filters } = action.payload
      state.commitmentDurations = data
      state.loading = null
      state.pagination = filters
      state.success = 'GET'
    },
    getCommitmentDurationDataFailure: state => {
      state.loading = null
      //handling Errors
      state.error = 'GET'
    },
    resetMessages: state => {
      state.success = ''
      state.error = ''
      state.loading = null
    }
  }
})

// Actions generated from the slice
const {
  addCommitmentDuration,
  updateCommitmentDuration,
  removeCommitmentDuration,
  startLoading,
  resetMessages,
  getCommitmentDurationDataFailure,
  getCommitmentDurationDataSuccess
} = commitmentDurationSlice.actions

// export user selector to get the slice in any component
export const commitmentDurationSelector = state => state.commitmentDurationData

// export The reducer
const commitmentDurationReducer = commitmentDurationSlice.reducer
export default commitmentDurationReducer

// Actions
export const fetchCommitmentDuationData = () => async dispatch => {
  try {
    dispatch(startLoading('GET'))
    const { data } = await getMetaDataData('type/commitmentDuration')
    dispatch(getCommitmentDurationDataSuccess(data ?? []))
  } catch (error) {
    dispatch(getCommitmentDurationDataFailure())
  }
}

export const createCommitmentDuation = tax => async dispatch => {
  try {
    dispatch(startLoading('CREATE'))
    const data = await createMetadata({ ...tax, type: 'commitmentDuration' })
    dispatch(addCommitmentDuration(data))
  } catch (error) {
    dispatch(getCommitmentDurationDataFailure())
  }
}

export const deleteCommitmentDuation = id => async dispatch => {
  try {
    dispatch(startLoading('DELETE'))
    await editMetadata(id, { status: 'archived' })
    dispatch(removeCommitmentDuration(id))
  } catch (error) {
    dispatch(getCommitmentDurationDataFailure())
  }
}

export const editCommitmentDuation = tax => async dispatch => {
  try {
    const { id, ...rest } = tax
    dispatch(startLoading('UPDATE'))
    await editMetadata(id, { ...rest })
    dispatch(updateCommitmentDuration(tax))
  } catch (error) {
    dispatch(getCommitmentDurationDataFailure())
  }
}

export const cleanMessages = () => dispatch => {
  dispatch(resetMessages())
}
